import { initPopupCloseFunction, activateSemanticUI } from './popup';
import { handlePopupFormSubmit } from './utils/ajax-form-submit';
function deleteFile(fileId) {
    $.post({
        url: '/filer/radera/' + fileId
    }).done(function (response) {
        var element = document.getElementById('userfile-' + fileId);
        if (element) {
            element.outerHTML = '';
        }
    });
}
var running = false;
$('.ts-open-file-preview').on('click', function () {
    var fileId = $(this).data('id');
    if (running === false) {
        running = true;
        $.ajax({
            url: '/filer/nedladdnings-objekt',
            data: { fileId: fileId }
        }).done(function (response) {
            $('.preview-popup').parent().replaceWith(response);
            initPopupCloseFunction();
            $('.preview-popup').parent().addClass('visible');
        });
        setTimeout(function () { running = false; }, 3000);
    }
});
$('.ts-file-edit-form-btn').on('click', function () {
    var fileId = $(this).data('fileid');
    $('#edit-file-' + fileId + '-dialog').parent().addClass('visible');
    activateSemanticUI($('#edit-file-' + fileId + '-dialog'));
});
$('.ts-edit-file-dialog form').on('submit', function (e) {
    e.preventDefault();
    handlePopupFormSubmit($(this));
});
$('.ts-file-delete-form-btn').on('click', function () {
    var fileId = $(this).data('fileid');
    $('#delete-file-' + fileId + '-dialog').parent().addClass('visible');
});
$('.ts-delete-file-dialog form').on('submit', function (e) {
    e.preventDefault();
    handlePopupFormSubmit($(this));
});
function contains(array, element) {
    for (var i = array.length - 1; i >= 0; i--) {
        if (array[i] === element) {
            return true;
        }
    }
    return false;
}
